import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo-link">
              <span className="footer-logo">YANX</span>
            </Link>
            <p className="footer-tagline">Premium Men&apos;s Essentials</p>
            <p className="footer-description">
              Crafted for men who value fit, feel, and quiet confidence — from the first wear to
              every day after.
            </p>
          </div>

          <div className="footer-columns">
            <div className="footer-section">
              <h4 className="footer-heading">Explore</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/products">Products</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Contact</h4>
              <ul className="footer-contact">
                <li>
                  <a href="mailto:yanxwear@gmail.com">yanxwear@gmail.com</a>
                </li>
                <li>
                  <a href="tel:+919056800633">+91 90568 00633</a>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Follow</h4>
              <div className="social-icons">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <rect x="2" y="2" width="20" height="20" rx="5" />
                    <circle cx="12" cy="12" r="4" />
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                  </svg>
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">&copy; {currentYear} YANX. All rights reserved.</p>
          <p className="footer-motto">Built for comfort. Designed for confidence.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
